import React, { useEffect } from "react";
import { Button } from "@/components/shared/Button/Button";
import Title from "@/components/shared/Title/Title";
import LayoutOutside from "@/layout/LayoutOutside";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/auth/Auth";
import { Input } from "@/components/shared/Input/Input";
import Password from "@/assets/icons/Password";
import { useForgotPassword } from "./hooks/useForgotPassword";

export function ForgotPassword() {
  const {
    onSubmit,
    handleSubmit,
    register,
    errors,
    isPending,
    isError,
    isSuccess,
  } = useForgotPassword();
  const { t } = useTranslation("common");
  const { signOut } = useAuth();

  useEffect(() => {
    document.body.classList.add("no-scroll");
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, []);

  return (
    <LayoutOutside
      logout={signOut}
      text={t("backToLogin")}
      isLoading={isPending}
      isError={isError}
      isSuccess={isSuccess}
      classNameMainContainer="flex items-center justify-center h-[calc(100vh-80px)]"
    >
      <section className="space-y-8 rounded-lg max-w-[416px] w-full">
        <div className=" mb-5">
          <div className="rounded-full">
            <Password />
          </div>
        </div>
        <Title text={t("recoverPassword")} className="text-white" />
        <p className="text-gray-400 mt-4">
          {t("forgotPasswordText1")}{" "}
          <span className="text-white">{t("forgotPasswordText2")}</span>{" "}
          {t("forgotPasswordText3")}
        </p>
        <form className="mt-6 space-y-4" onSubmit={handleSubmit(onSubmit)}>
          <Input
            type="email"
            placeholder={t("email_placeholder")}
            label={t("email")}
            {...register("email")}
            helperText={errors?.email?.message}
          />
          <Button
            type="submit"
            variant="primary"
            className="w-full"
            disabled={isPending}
          >
            {t("sendVerificationEmail")}
          </Button>
        </form>
      </section>
    </LayoutOutside>
  );
}
